import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    budget: {budgets: [], billingStart: 1},
};

const fetchBudgetStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchBudgetSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, budget: action.budget})
};

const fetchBudgetFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const saveBudgetStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const saveBudgetSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, budget: action.budget})
};

const saveBudgetFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.BUDGET_FETCH_START: return fetchBudgetStart(state, action);
        case actionTypes.BUDGET_FETCH_SUCCESS: return fetchBudgetSuccess(state, action);
        case actionTypes.BUDGET_FETCH_FAIL: return fetchBudgetFail(state, action);
        case actionTypes.SAVE_BUDGET_START: return saveBudgetStart(state, action);
        case actionTypes.SAVE_BUDGET_SUCCESS: return saveBudgetSuccess(state, action);
        case actionTypes.SAVE_BUDGET_FAIL: return saveBudgetFail(state, action);
        default: return state;
    }
};

export default reducer;